// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QrCode_wrapper__6Wplx","overlay":"QrCode_overlay__D3_9j","errorMessage":"QrCode_errorMessage__ftpbp"};